import { render, staticRenderFns } from "./matchingInfo.vue?vue&type=template&id=0f1404a2&"
import script from "./matchingInfo.vue?vue&type=script&lang=js&"
export * from "./matchingInfo.vue?vue&type=script&lang=js&"
import style0 from "./matchingInfo.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "matchingInfo.vue"
export default component.exports